// Search, as natively (SearchView.swift, StashSearch.swift, SearchMatch.swift): your own
// stashes or Explore's public ones, and for your own, results by kind. Pure.

export type SearchCorpus = "yours" | "public";
export const CORPUS_TITLES: Record<SearchCorpus, string> = { yours: "My library", public: "Explore" };
export const SEARCH_DEBOUNCE_MS = 500;

export const SEARCH_FACETS = ["all", "stashes", "stuff", "collections", "tags"] as const;
export type SearchFacet = (typeof SEARCH_FACETS)[number];
export type ResultFacet = Exclude<SearchFacet, "all">;
export const FACET_TITLES: Record<SearchFacet, string> = {
  all: "All",
  stashes: "Stashes",
  stuff: "Stuff",
  collections: "Collections",
  tags: "Tags",
};

/** How many of each kind All shows before "See all". */
export const ALL_PREVIEW: Record<ResultFacet, number> = { stashes: 25, stuff: 10, collections: 10, tags: 10 };

const fold = (value: string) => value.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();

/** Every word of the query appears in the text, ignoring case and accents (native SearchMatch). */
export function searchMatches(text: string, query: string): boolean {
  const words = fold(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return false;
  const haystack = fold(text);
  return words.every(word => haystack.includes(word));
}

/**
 * When complete results are thin (four or fewer), offer the same query in Explore
 * (native offersPublicSearch). All needs every kind complete.
 */
export function offersExplore(
  facet: SearchFacet,
  counts: Record<ResultFacet, number>,
  complete: Record<ResultFacet, boolean>,
): boolean {
  const kinds = SEARCH_FACETS.filter((f): f is ResultFacet => f !== "all");
  if (facet === "all") return kinds.every(kind => complete[kind]) && kinds.reduce((sum, kind) => sum + counts[kind], 0) <= 4;
  return complete[facet] && counts[facet] <= 4;
}
